import React from 'react';
// APOLLO
import { graphql } from 'react-apollo';
import questionTemplatesQuery from 'ApolloClient/Queries/questionTemplates';
// ANTD
import Form from 'antd/lib/form';
import TextInput from 'components/inputs/TextInput';
import Card from 'antd/lib/card';
import Button from 'components/common/Button';

const FormItem = Form.Item;

export class QuestionnairePreview extends React.Component {
  state = {
    results: [],
    loading: false,
    complete: false,
  };

  renderItem = (item, index) => (
    <div key={item}>
      <p>{item}</p>
      <FormItem>
        <TextInput
          onChange={answer => {
            let results = this.state.results;
            results[index] = { question: item, answer };
            this.setState({ results });
          }}
          value={this.state.results[index] ? this.state.results[index].answer : null}
          size="large"
        />
      </FormItem>
    </div>
  );

  renderContent = template => (
    <div>
      {template.questions.map((item, index) => this.renderItem(item, index))}
      <Button fullWidth disabled loading={this.state.loading} onClick={this.onSubmit}>
        SUBMIT
      </Button>
    </div>
  );

  render() {
    const { questionTemplates, loading } = this.props.questionTemplatesQuery;

    if (loading) {
      return null;
    }

    let filtered = questionTemplates.filter(item => item._id === this.props.match.params.questionTemplateId);
    let template = filtered[0];

    if (!template) {
      return null;
    }

    return (
      <div
        style={{
          padding: 4,
          width: 1100,
          maxWidth: '100%',
          margin: 'auto',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <Card
          style={{
            padding: 4,
            width: 600,
            maxWidth: '100%',
            margin: 'auto',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            {this.props.currentUser
              && this.props.currentUser.organization
              && this.props.currentUser.organization.image && (
              <img
                style={{ textAlign: 'center', maxHeight: 100, margin: '25px auto' }}
                src={this.props.currentUser.organization.image}
                alt="logo"
              />
            )}
          </div>
          {this.renderContent(template)}
        </Card>
      </div>
    );
  }
}

export default graphql(questionTemplatesQuery, { name: 'questionTemplatesQuery' })(QuestionnairePreview);



// WEBPACK FOOTER //
// ./src/routes/client-questionnaire-preview/index.js